
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import IoablePageMixin from "@/router/IoablePageMixin";
import PathInfoMixin from "@/router/PathInfoMixin";
import IconBtn from "@/components/molecules/IconBtn.vue";
import {defineComponent} from "vue";
import {TradeContractFormat} from "@/store/modules/hcs/tradeContractFormat/model";
import TradeContractFormatView, {
  createTradeContractFormatView
} from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import Formatter from "@/utils/Formatter";
import IconBtns from "@/components/molecules/IconBtns";
import Swal from "sweetalert2";
import FormatTable from "@/components/pages/contract/TradeContractFormat/FormatTable.vue";

export default defineComponent({
  name: "FormatTab",
  components: {
    FormatTable,
    IconBtns,
    TableInline, TextFieldLike,
    IconBtn,
    TabItemTemplate
  },
  inject: ['tabItemBounds'],
  mixins: [
    IoablePageMixin,
    PathInfoMixin,
    TableUtil,
    Formatter,
  ],
  data() {
    return {
      tradeContractFormats: [] as TradeContractFormat[],
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    readonly(): boolean {
      return !this.isEditable;
    },
    tradeContractFormatsView(): TradeContractFormatView[] {
      return this.tradeContractFormats.map(s => createTradeContractFormatView(s, this.$store));
    }
  },
  methods: {
    ...mapActions({
      fetchTradeContractFormats: "hcs/tradeContractFormat/findList",
      deleteTradeContractFormats: "hcs/tradeContractFormat/delete",
    }),
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    async load() {
      this.tradeContractFormats = await this.fetchTradeContractFormats();
    },
    async handleDeleteButtonClick(row: TradeContractFormat) {
      const {value: confirm} = await Swal.fire({
        title: '確認',
        icon: 'info',
        html: `本当に取引契約フォーマット <strong>${row.name}</strong> を削除してよろしいですか。`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ"
      });
      if(!confirm) {
        return;
      }

      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
      });
      try {
        await this.deleteTradeContractFormats(row.id);

        this.showSnackbar({
          message: `取引契約フォーマット ${row.name} を削除しました`,
        });
      } catch (e) {
        console.error(e);
        this.showSnackbar({
          color: 'failed',
          message: `取引契約フォーマット ${row.name} の削除に失敗しました`,
        });
      } finally {
        loading.close();
      }
    },
    handleDraftButtonClick() {
      this.showSnackbar({
        message: 'フォーマットを作成するデータプロファイルを選び、提供または利用ボタンを押してください。',
        timeout: 30000
      });
    },
  },
});
